(() => {
  document.querySelectorAll('.fs-verbatim-hero').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('[data-fs-verbatim-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-fs-verbatim-hero-dot]'));
    const prevBtn = hero.querySelector('[data-fs-verbatim-hero-prev]');
    const nextBtn = hero.querySelector('[data-fs-verbatim-hero-next]');
    if (slides.length < 2) return;

    let current = 0;

    const loadSlideMedia = (slide) => {
      const img = slide.querySelector('img[data-src]');
      if (img) {
        img.src = img.dataset.src;
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      }
      const video = slide.querySelector('video[data-fs-verbatim-hero-video]');
      if (video) {
        const source = video.querySelector('source[data-src]');
        if (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          video.load();
        }
        video.play().catch(() => {});
      }
    };

    const pauseSlideMedia = (slide) => {
      slide.querySelector('video')?.pause();
    };

    const show = (index) => {
      slides[current].classList.remove('fs-verbatim-hero__slide--active');
      pauseSlideMedia(slides[current]);
      dots[current]?.classList.remove('fs-verbatim-hero__dot--active');
      dots[current]?.setAttribute('aria-selected', 'false');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('fs-verbatim-hero__slide--active');
      dots[current]?.classList.add('fs-verbatim-hero__dot--active');
      dots[current]?.setAttribute('aria-selected', 'true');
      loadSlideMedia(slides[current]);
    };

    prevBtn?.addEventListener('click', () => show(current - 1));
    nextBtn?.addEventListener('click', () => show(current + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));

    let autoplay = setInterval(() => show(current + 1), 6000);
    hero.addEventListener('mouseenter', () => clearInterval(autoplay));
    hero.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => show(current + 1), 6000);
    });
  });
})();
